// extracted by mini-css-extract-plugin
export var container = "styles-module--container--kLlP0";
export var containerCenter = "styles-module--containerCenter--Tve9r";
export var containerLeft = "styles-module--containerLeft--1KFIr";
export var containerRight = "styles-module--containerRight--LYYcg";
export var desktop = "1340px";
export var giant = "2200px";
export var grid = "styles-module--grid--dJLk4";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var link = "styles-module--link--sdSya";
export var list = "styles-module--list--4PeWD";
export var listItem = "styles-module--listItem--gVlxq";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";